<template>
  <div>
    <v-main>
      <div
        class="col-md-12 ml-sm-auto col-lg-12 pa-4"
        v-show="dataintab === true"
      >
        <v-row>
          <v-col>
            <h2>รายงานใบเสร็จลูกค้าที่ใช้บริการจากระบบ Loyverse</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding-top: 0">
            <p style="margin-bottom: 0">
              หมายเหตุ : คะแนนลูกค้าบางคนที่ไม่เท่ากัน
              ต้องรอซิงค์ข้อมูลตามเวลาดังนี้
            </p>
            <p style="margin-bottom: 0">1. 00.00 น.</p>
            <p style="margin-bottom: 0">2. 08.00 น.</p>
            <p style="margin-bottom: 10px">3. 16.00 น.</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  label="ค้นหาตามวันที่"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="clearTextField()"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title scrollable range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(date), getDataFilter()"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-text-field
              v-model="memberSearch"
              label="ค้นหา ชื่อ / เบอร์โทร"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <v-card>
          <v-data-table
            :headers="headers"
            :items="ListReceipt"
            :search="memberSearch"
            :custom-filter="memberFilter"
            :items-per-page="5"
            class="elevation-1"
            :loading="loading"
            loading-text="Loading... Please wait"
          >
            <template v-slot:[`item.created_at`]="{ item }">
                {{ convertDateUTC(item.created_at) }}
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx'
import memberSearch from '@/mixins/memberSearch'
export default {
  mixins: [memberSearch],
  components: {
    moment,
    downloadExcel: JsonExcel,
    XLSX
  },
  data () {
    return {
      desserts: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: 1
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: 1
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: 7
        }
      ],
      menu: false,
      PK: '',
      path: '/package/', // Path Model
      PATH: '/packageQRcode/',
      returnLink: '/Master/Package',
      session: this.$session.getAll(),
      tab: null,
      dialogPackageMember: false,
      valid: true,
      menu1: false,
      dataintab: true,

      data_notify: [],
      date: [],
      headers: [
        { text: 'วันที่ใช้บริการ', value: 'created_at' },
        {
          text: 'เลขที่ใบเสร็จ',
          value: 'receipt_number',
          sortable: false,
          align: 'center'
        },
        { text: 'ลูกค้า', value: 'nameCustomer', sortable: false },
        {
          text: 'เบอร์โทรศัพท์',
          value: 'tel',
          sortable: false,
          align: 'center'
        },
        {
          text: 'คะแนนระบบ Loyverse',
          value: 'customer.total_points',
          sortable: false,
          align: 'center'
        },
        {
          text: 'คะแนนระบบ Betask',
          value: 'currentPoint',
          sortable: false,
          align: 'center'
        }
        // { text: 'เลขที่ใบเสร็จ', value: 'action', sortable: false, align: 'center' },
        // { text: 'เลขที่ใบเสร็จ', value: 'action', sortable: false, align: 'center' }
      ],
      ListReceipt: [],
      dialogData: false,
      data_receipt: [],
      loading: true
    }
  },
  computed: {
    dateRangeText () {
      return this.date.join(' - ')
    }
  },

  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.getReceipt()
  },
  methods: {
    async getReceipt () {
      try {
        this.loading = true
        this.data_receipt = []
        const res = await axios.post(this.DNS_IP + '/getReport-Loyverse')
        if (res.status === 200) {
          this.ListReceipt = res.data.arr
          console.log(this.ListReceipt)
        } else {
          this.ListReceipt = []
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.ListReceipt = []
      } finally {
        this.loading = false
      }
    },
    convertDateUTC (dateString) {
      const date = new Date(dateString)
      date.setHours(date.getHours() + 7)
      const day = date.getUTCDate().toString().padStart(2, '0')
      const month = (date.getUTCMonth() + 1).toString().padStart(2, '0')
      const year = date.getUTCFullYear()
      const hours = date.getUTCHours().toString().padStart(2, '0')
      const minutes = date.getUTCMinutes().toString().padStart(2, '0')
      return `${day}/${month}/${year} ${hours}:${minutes}`
    },
    getNotify () {
      this.data_notify = []
      axios
        .get(
          this.DNS_IP +
            '/Log_Notify_Birthday/get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then((res) => {
          console.log('s', res.data.length)
          if (res.data.length > 0) {
            this.data_notify = res.data
            console.log(this.data_notify)
          } else {
            this.data_notify = []
          }
        })
    },
    getMember (item) {
      console.log(item)
      this.Listmember = JSON.parse(item.member)
      console.log(this.Listmember[0].name)
    },
    clearTextField () {
      this.date = []
      this.getDataFilter()
    },
    getDataFilter () {
      console.log('Date', this.date)
      this.ListReceipt = []
      if (this.date.length > 0) {
        this.loading = true
        axios.post(this.DNS_IP + '/getReport-date-Loyverse', { date: this.date }).then((res) => {
          if (res.data.arr.length > 0) {
            this.ListReceipt = res.data.arr
            console.log('dd', res)
            this.loading = false
          } else {
            this.ListReceipt = []
            console.log('dd', res)
            this.loading = false
          }
        })
      }
    }
  }
}
</script>
<style scoped>
h3 {
  font-size: 18.72px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/reportReceipt.vue